import React from 'react';
import { Card } from '@sravni/react-design-system/lib/Card';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile, useStyles } from '@sravni/react-utils';
import modules_1be33e45 from '../styles/StoresBanner.module.less.js';
import { AppleIcon } from './AppleIcon.js';
import { GoogleIcon } from './GoogleIcon.js';
import { HuaweiIcon } from './HuaweiIcon.js';
import { RuStoreIcon } from './RuStoreIcon.js';
import { Store } from './Store.js';

const StoresBanner = ({ refs, variant, className, ...rest }) => {
    const isMobile = useIsMobile();
    const cx = useStyles(modules_1be33e45);
    const isPrimary = variant === 'primary';
    return (React.createElement(Card, { size: 16, color: isPrimary ? 'dark' : 'light', className: cx(className, 'container'), ...rest },
        React.createElement(Space, { size: 12, direction: "column", className: !isMobile ? 'h-ml-8 h-mr-8' : '' },
            React.createElement(Heading, { level: 5 }, "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435"),
            React.createElement(Space, { size: 12, direction: "row", inline: true },
                React.createElement(Space, { size: 8, direction: "column", className: modules_1be33e45.firstColumn },
                    React.createElement(Store, { ref: refs["APPLE_STORE" /* STORES.APPLE_STORE */], variant: variant, store: "APPLE_STORE" /* STORES.APPLE_STORE */, storeIcon: React.createElement(AppleIcon, null) }),
                    React.createElement(Store, { ref: refs["HUAWEI_APP_GALLERY" /* STORES.HUAWEI_APP_GALLERY */], variant: variant, store: "HUAWEI_APP_GALLERY" /* STORES.HUAWEI_APP_GALLERY */, storeIcon: React.createElement(HuaweiIcon, null) })),
                React.createElement(Space, { size: 8, direction: "column", className: modules_1be33e45.secondColumn },
                    React.createElement(Store, { ref: refs["GOOGLE_PLAY" /* STORES.GOOGLE_PLAY */], variant: variant, store: "GOOGLE_PLAY" /* STORES.GOOGLE_PLAY */, storeIcon: React.createElement(GoogleIcon, null) }),
                    React.createElement(Store, { ref: refs["RU_STORE" /* STORES.RU_STORE */], variant: variant, store: "RU_STORE" /* STORES.RU_STORE */, storeIcon: React.createElement(RuStoreIcon, null) }))))));
};
StoresBanner.displayName = 'StoresBanner';

export { StoresBanner };
//# sourceMappingURL=StoresBanner.js.map
